/* RESPONSIBLE TEAM: team-ml */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

export default class SdrFollowupEmail extends Step {
  get supportedChannels() {
    return SUPPORTED_CHANNELS.sdrFollowupEmail;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation];
  }

  static get requiredBillingFeature() {
    return null;
  }

  static createNewStep(store: Store): SdrFollowupEmail {
    return store.createRecord('operator/visual-builder/step/sdr-followup-email', {
      type: 'operator/visual-builder/step/sdr-followup-email',
    });
  }
}
